import $ from 'jquery'

import FormAsync from './form-async'

const Selector = {
  DATA_TOGGLE: '[data-toggle="editable"]',
  EDITABLE: '.editable',
  EDITABLE_INPUT: '.editable input',
  INPUT: 'input'
}

if ($(Selector.DATA_TOGGLE).length > 0) {
  // Toggle editable input on click
  $(document).on('click', Selector.DATA_TOGGLE, evt => {
    $(evt.currentTarget)
      .closest(Selector.EDITABLE)
      .find(Selector.INPUT).first()
      .readonly('toggle')
  })

  // Disable editing on ajax form submit/reset
  $(Selector.EDITABLE).closest(FormAsync.Selector.DATA_FORM_ASYNC).on(
    `${FormAsync.Event.SUBMITTING} ${FormAsync.Event.RESETTING}`, function () {
      $(this).find(Selector.EDITABLE_INPUT).readonly(true)
    }
  )
}
